export enum PrimaryButtonType {
    None,
    AddAttendees,
    CompleteTraining,
    ShowFeedback,
    DownloadCompletedEventMemberList,
    DownloadMemberList,
    DownloadESignatureQRCode,
    Edit,
}

export enum SecondaryButtonType {
    None,
    CopyLink,
    DownloadMemberList,
    DownloadCompletedEventMemberList,
    DownloadIcs,
    SendInfo,
    Edit,
    Cancel,
    Delete,
    AddAttendees,
    DownloadESignatureQRCode,
    ActivityLog,
    CopyFeedbackLink,
}